"use client";
import * as React from "react";
const SvgSentimentVerySatisfiedFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m10.8-.8a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4M6.4 6A1.2 1.2 0 1 1 4 6a1.2 1.2 0 0 1 2.4 0M8 12.8c-1.82 0-3.38-1.33-4-3.2h8c-.62 1.87-2.18 3.2-4 3.2", clipRule: "evenodd" }));
export {
  SvgSentimentVerySatisfiedFilled as default
};
